import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {},
  logo: {
    minWidth: 140,

    '& a': {
      display: 'block',
      maxWidth: 160,
    },
  },
  nav: {
    '& ul': {
      margin: 0,
      padding: 0,
      whiteSpace: 'nowrap',

      '& li': {
        display: 'inline-block',
        listStyle: 'none',

        '& a': {
          color: theme.palette.text.secondary,
          fontWeight: 500,
          padding: theme.spacing(1),
          textDecoration: 'none',
          '&:hover': {
            color: theme.palette.primary.main,
          },
          [theme.breakpoints.between('xs', 'md')]: {
            fontSize: 12,
          },
        },
      },
    },
  },
}));

export default useStyles;
